import { toast } from "sonner";
import { Pencil, Trash2 } from "lucide-react";
import { api } from "@/lib/api";
import { servicesChanged } from "@/lib/services";

export const ItemActions = ({ it, onEdit }) => {
  const remove = async () => {
    if (!window.confirm(`Apagar "${it.label}"?`)) return;
    try { await api.delete(`/services/${it.id}`); toast.success("Apagado"); servicesChanged(); }
    catch (e) { toast.error(e.response?.data?.detail || "Falha ao apagar"); }
  };
  const b = "rounded-lg border border-[#1F293D] p-2 text-slate-400 transition-colors hover:bg-[#1A2234] hover:text-white";
  return (
    <div className="flex gap-1.5">
      <button data-testid={`service-edit-${it.id}`} onClick={onEdit} title="Editar" className={b}><Pencil className="h-3.5 w-3.5" /></button>
      <button data-testid={`service-delete-${it.id}`} onClick={remove} title="Apagar" className={`${b} hover:text-red-300`}><Trash2 className="h-3.5 w-3.5" /></button>
    </div>
  );
};
